import { DocumentGeneratedEntity } from "./generated/DocumentGeneratedEntity";

export abstract class DocumentEntity extends DocumentGeneratedEntity {
    // Comment to preserve new line
}
